import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { Grid, Modal } from '@mui/material';

import GpsMap from './SubComponents/GpsMap';
import MapFilters from './SubComponents/MapFilters';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  border: '2px solid #000',
  borderRadius: '20px',
  overflow: 'hidden',
  height: '70%',
  width: '70%',
  outline: 'none',
};

const GpsMapTrackPunches = ({
  punchAndPinCoordinates = [],
  date,
  workCoordinates,
  title,
  open,
  handleOnClose,
}) => {
  const [markers, setMarkers] = useState(punchAndPinCoordinates);

  const handleOnFilterChange = useCallback((event) => {
    setMarkers((prevVal) =>
      prevVal.map((val) =>
        event.target.name === val?._id ? { ...val, checked: event.target.checked } : val
      )
    );
  }, []);

  return (
    <Modal
      open={open}
      onClose={handleOnClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      data-testid="map-modal"
    >
      <Grid container item xs sx={style}>
        <Grid container item xs sx={{ height: '100%' }}>
          <GpsMap
            markers={markers.filter((m) => m?.checked === true)}
            workLocationMarker={workCoordinates}
          />
        </Grid>
        <MapFilters
          title={title}
          date={date}
          onClose={handleOnClose}
          list={markers}
          onChange={handleOnFilterChange}
        />
      </Grid>
    </Modal>
  );
};

GpsMapTrackPunches.propTypes = {
  punchAndPinCoordinates: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      lat: PropTypes.number,
      lng: PropTypes.number,
      name: PropTypes.string,
      radius: PropTypes.number,
      checked: PropTypes.bool,
      isSuspicious: PropTypes.bool,
    })
  ),
  date: PropTypes.number,
  workCoordinates: PropTypes.shape({
    _id: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    name: PropTypes.string,
    radius: PropTypes.number,
  }),
  open: PropTypes.bool,
  handleOnClose: PropTypes.func,
  title: PropTypes.string,
};

export default GpsMapTrackPunches;
